import styles from './DeliverySend.module.css'
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import SelectUnit, {SelectUnitDataInt, SelectUnitRefInt} from "../../FormTemplate/SelectUnit/SelectUnit";
import React, {use, useEffect, useRef, useState} from "react";
import InputItem, {IRefInputItem} from "../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import LoggerItem, {ILoggerItem} from "../../FormTemplate/LoggerItem/LoggerItem";
import useLongTask from "../../Util/LongTaskItem/UseLongTask";


export default function DeliverySend()
{

    const [msgList, setMsgList] = useState<SelectUnitDataInt[]>([
        {
            name: "Макс",
            val: "MAX"
        },
        {
            name: "Телеграм",
            val: "TELEGRAM"
        },
    ])

    const [msgVal, setMsgVal] = useState<string[]>([])

    const [work, setWork] = useState(false)
    const refLog = useRef<ILoggerItem>(null)
    const sendData = useRef<{
        text: string
        msgList:string[]
    }>(null)
    const [ldrSend,rSend,exSend] = useApiQuery("/surkov/send","post",sendData);
    const [text, setText] = useState("")
    const refState = useRef<ErrorLineItemRef>(null)
    const [warText, setWarText] = useState<SelectUnitDataInt[]>([
        {
            name: "1: Обычный",
            val: "Добрый день!\nПросим оплатить услуги связи Билайн до 15 числа!"
        },
        {
            name: "2: Предупреждение 1",
            val: "Уважаемый Абонент! Приятно, когда все обязательства исполнены! Напоминаем, что необходимо оплатить счет за услуги связи до 15 числа. Пожалуйста, поспешите с оплатой. С заботой о Вас! Ваш Билайн!"
        },
        {
            name: "3: Предупреждение 2",
            val: "Уважаемый Абонент! Приятно, когда все обязательства исполнены! Напоминаем, что сегодня последний день оплаты счетов за услуги связи. Пожалуйста, поспешите с оплатой. С заботой о Вас! Ваш Билайн!"
        },
        {
            name: "4: Предупреждение 3",
            val: "Уважаемый Абонент!\nБлокировка Вашего номера прогнозируется сегодня. Просим СРОЧНО оплатить задолженность за услуги связи Билайн!\n"
        },
    ])
    const [ldrSendTask, exSendTask] = useLongTask(100,5000, (state, data, code,cnt)=>onResultTaskTick(state, data,code,cnt),(state, data, code,cnt)=>onResultTaskTick(state, data,code,cnt),true)



    const onResultTaskTick = (state: boolean, data:any , code:number ,cnt: number)=>{
        if(data?.log && Array.isArray(data?.log) && refLog.current)refLog.current.log(data?.log)
        if(state)
        {
            if(refState.current)refState.current.show("Задача выполнена", false,3000)
            setWork(false)
            return
        }
    }


    const handleSend = ()=>{
        if(text.length < 10)
        {
            if(refState.current)refState.current.show("Не корретен текст сообщения", true, 3000)
            return
        }
        if(!msgVal.length )
        {
            if(refState.current)refState.current.show("Не выбран мессенджер", true, 3000)
            return
        }
        sendData.current ={
            text: text,
            msgList:msgVal
        }
        if(refLog.current)refLog.current.clear()
        setWork(true)
        exSend().then((e)=>{
            if(e?.success)
            {
                exSendTask(e?.payload)
                return
            }
            setWork(false)
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 5000)

        })

    }


    return (
        <div className={styles.mainCont}>
            <MainFormTemplate title={"Рассылка по абонентам"} maxWidth={"1000px"}>
                <div className={"row"}>
                    <div className={styles.ldrCont}>
                        <div className={styles.ldrTitle}>Прогресс работы</div>
                        <div className={styles.ldr}>
                            <WaitLoader loading={work || ldrSend} api={rSend} onlyLoading={true}>

                            </WaitLoader>
                        </div>
                        {work && <div className={styles.ldrTitle}>«{"Процесс"}»</div>}

                    </div>
                </div>


                <div className={"row"}>

                    <div className={styles.rowCont}>
                        <div className={styles.seCont}>
                            <SelectUnit capt={"Текст"} inData={warText}
                                getVal={(e)=>setText(e[0])}
                            ></SelectUnit>

                            <SelectUnit capt={"Мессенджер"} inData={msgList} multiSelect={true}
                                        getVal={(e)=>setMsgVal(e)}
                            ></SelectUnit>

                        </div>

                    </div>
                </div>

                <div className={"row"}>

                        <InputItem
                            mode={"e"}
                            title={"Текст"}
                            val={text}
                            minWidth={"100%"}
                            titleShift={-2}
                            inputType={2}
                            lineCount={4}
                            onChange={(e)=>setText(e)}
                        />
                    </div>
                <div className={"row"}>
                    <LoggerItem
                        lineCount={10}
                        title={"Лог"}
                        ref={refLog}
                    />
                </div>


                <div className={"row"}>
                    <ErrorLineItem ref={refState}></ErrorLineItem>
                </div>



                <div className={"row w-100"}>
                    <div className={["col-sm-12 d-flex align-self-center", styles.btGr].join(' ')}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    disabled={work}
                                    onClick={()=>handleSend()}
                            >Отправить</button>


                        </div>
                    </div>
                </div>

            </MainFormTemplate>
        </div>
    )
}